// Estado de cuenta a la cadena: su periodo, el orden de la lista y lo depositado por vendedor.
import type { RetailCommission } from '@fiado/type-kit';
import { formatShortDayWithYearMx } from '@/lib/dateHelpers';

type Statement = RetailCommission.CommissionChainStatement;
type Payment = RetailCommission.CommissionPayment;

/** "05 oct 26 – 11 oct 26": los días que cubre el cobro. */
export function statementPeriodText(statement: Pick<Statement, 'startDate' | 'endDate'>): string {
    return `${formatShortDayWithYearMx(statement.startDate)} – ${formatShortDayWithYearMx(statement.endDate)}`;
}

/** El más reciente primero. */
export function sortStatements(statements: readonly Statement[]): Statement[] {
    return [...statements].sort((a, b) => b.startDate.localeCompare(a.startDate));
}

export interface StatementSellerRow {
    sellerId: string;
    sellerName: string;
    paymentsCount: number;
    amountCents: number;
}

/** Lo depositado a cada vendedor en el periodo, del mayor al menor. */
export function statementBySeller(
    payments: readonly Payment[],
    sellerName: (sellerId: string) => string,
): StatementSellerRow[] {
    const bySeller = new Map<string, StatementSellerRow>();
    for (const payment of payments) {
        const row = bySeller.get(payment.sellerId) ?? {
            sellerId: payment.sellerId,
            sellerName: sellerName(payment.sellerId),
            paymentsCount: 0,
            amountCents: 0,
        };
        row.paymentsCount += 1;
        row.amountCents += payment.amountCents;
        bySeller.set(payment.sellerId, row);
    }
    return [...bySeller.values()].sort(
        (a, b) =>
            b.amountCents - a.amountCents || a.sellerName.localeCompare(b.sellerName, 'es-MX'),
    );
}
